import { compose } from "@reduxjs/toolkit";
import { connect } from "react-redux";

import { closeModal } from "../../../redux/slices/modal/modal.slice";
import ModalRoot from "./ModalRoot.layout";

const mapStateToProps = (state: any) => ({
    modalName: state.modal.modalName,
    data: state.modal.data,
    isOpen: state.modal.isOpen,
});

const mapDispatchToProps = (dispatch: any) => ({
    dispatchHideModal: () => dispatch(closeModal()),
});

const decorate = compose(connect(mapStateToProps, mapDispatchToProps));

export default decorate(ModalRoot);
